var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useDefaultApiParams } from 'src/hooks';
export const useFetchRufusPills = () => {
    const { asin } = useParams();
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    return useQuery({
        queryKey: [
            'fetchRufusPills',
            asin,
            defaultApiParams.marketplaceId,
            defaultApiParams.xJoinId,
            defaultApiParams.xUserLinked,
        ],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return yield HandshakePainterServiceApiV1.fetchRufusPills({
                asin: asin,
                xJoinId: defaultApiParams.xJoinId,
                xUserLinked: defaultApiParams.xUserLinked,
                marketplaceId: defaultApiParams.marketplaceId,
            });
        }),
        enabled: !!asin,
    });
};
